
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import logo from '../assets/logo.png';
// import axios from 'axios';

// function numberToWords(num) {
//   const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
//   const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
//   if (num === 0) return 'Zero';
//   function convert(n) {
//     if (n < 20) return ones[n];
//     if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
//     if (n < 1000) return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + convert(n % 100) : '');
//     if (n < 100000) return convert(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + convert(n % 1000) : '');
//     if (n < 10000000) return convert(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + convert(n % 100000) : '');
//     return convert(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + convert(n % 10000000) : '');
//   }
//   const r = Math.floor(num);
//   const p = Math.round((num - r) * 100);
//   return convert(r) + ' Rupees' + (p > 0 ? ' and ' + convert(p) + ' Paise' : '') + ' Only';
// }

// function fDate(s) {
//   if (!s) return '';
//   const d = new Date(s);
//   return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
// }

// function buildInvoiceHTML({ logoSrc, rows, cl, subtotal, sgst, cgst, net, notes, emptyCount }) {
//   const rowsHTML = rows.map((r, i) => `
//     <tr style="background:${i % 2 === 0 ? '#ffffff' : '#fff8f3'};">
//       <td style="padding:9px 8px;border:1px solid #ddd;text-align:center;font-size:13px;">${i + 1}</td>
//       <td style="padding:9px 8px;border:1px solid #ddd;font-weight:500;font-size:13px;">${r.description || ''}</td>
//       <td style="padding:9px 8px;border:1px solid #ddd;text-align:center;font-size:13px;">${r.length || '-'}</td>
//       <td style="padding:9px 8px;border:1px solid #ddd;text-align:center;font-size:13px;">${r.height || '-'}</td>
//       <td style="padding:9px 8px;border:1px solid #ddd;text-align:center;font-size:13px;">${r.sqft || '-'}</td>
//       <td style="padding:9px 8px;border:1px solid #ddd;text-align:right;font-size:13px;">${r.rate ? '&#8377;' + parseFloat(r.rate).toLocaleString('en-IN') : '-'}</td>
//       <td style="padding:9px 8px;border:1px solid #ddd;text-align:right;font-weight:600;font-size:13px;">${r.total_rate ? '&#8377;' + parseFloat(r.total_rate).toLocaleString('en-IN') : '-'}</td>
//     </tr>`).join('');

//   const emptyRowsHTML = Array.from({ length: emptyCount }).map(() =>
//     `<tr>${Array(7).fill('<td style="padding:11px 8px;border:1px solid #ddd;">&nbsp;</td>').join('')}</tr>`
//   ).join('');

//   const gstRowsHTML = cl.has_gst ? `
//     <tr>
//       <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;background:#f9f9f9;font-size:13px;">SGST (9%):</td>
//       <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;font-size:13px;">&#8377;${sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//     </tr>
//     <tr>
//       <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;background:#f9f9f9;font-size:13px;">CGST (9%):</td>
//       <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;font-size:13px;">&#8377;${cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//     </tr>` : '';

//   const phoneHTML = cl.customer_phone
//     ? `<div style="margin-top:4px;font-size:13px;"><strong>Phone:</strong> ${cl.customer_phone}</div>` : '';
//   const gstNoHTML = cl.has_gst && cl.customer_gst
//     ? `<div style="margin-top:4px;font-size:13px;"><strong>GST No:</strong> ${cl.customer_gst}</div>` : '';

//   const notesHTML = notes ? `
//     <div style="background:#fff8f3;border:1px solid #ffcc99;border-radius:6px;padding:10px 13px;margin:0 0 13px 0;font-size:12px;">
//       <div style="font-weight:700;color:#ff6b00;margin-bottom:5px;font-size:11px;text-transform:uppercase;">Notes / Comments:</div>
//       <div style="white-space:pre-wrap;font-size:12px;color:#555;line-height:1.5;">${notes.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>
//     </div>` : '';

//   return `
// <div style="width:100%;font-family:Arial,Helvetica,sans-serif;font-size:13px;color:#000000;background:#ffffff;padding:18px 22px;box-sizing:border-box;">
//   <div style="height:8px;background:#ff6b00;margin-bottom:14px;"></div>
//   <table style="width:100%;border-collapse:collapse;margin-bottom:10px;" cellpadding="0" cellspacing="0">
//     <tr>
//       <td style="width:110px;vertical-align:middle;"></td>
//       <td style="text-align:center;vertical-align:middle;padding:0 10px;">
//         <table style="width:100%;border-collapse:collapse;margin-bottom:5px;" cellpadding="0" cellspacing="0">
//           <tr>
//             <td style="font-size:12px;font-weight:700;color:#444;text-align:left;">GST: 33CGAPS5480A2ZN</td>
//             <td style="font-size:12px;font-weight:700;color:#444;text-align:right;">Cell: 9965113567</td>
//           </tr>
//         </table>
//         <div style="font-size:17px;font-weight:900;color:#0a0a0a;line-height:1;margin-bottom:4px;">உ</div>
//         <div style="font-size:17px;font-weight:800;color:#333;margin-bottom:4px;">பெத்தனசாமி துணை</div>
//         <div style="font-size:28px;font-weight:900;color:#ff6b00;letter-spacing:2px;line-height:1.15;">AKSHAYA</div>
//         <div style="font-size:15px;font-weight:700;color:#333;margin-top:2px;">Wood Furniture &amp; Interiors</div>
//         <div style="font-size:12px;color:#555;margin-top:5px;line-height:1.6;">
//           12A, Digital Garden, opposite Rainbow factory, near Sagaja Yoga Mandabam,<br/>
//           Kuralikundu Road, Annanji, Theni - 625531
//         </div>
//         <div style="font-size:12px;color:#ff6b00;margin-top:6px;">
//           www.akshayainteriors.in &nbsp;|&nbsp; akshayawoodfurnitures@gmail.com
//         </div>
//       </td>
//       <td style="width:110px;vertical-align:middle;text-align:center;">
//         <img src="${logoSrc}" alt="Logo" style="height:95px;width:95px;object-fit:contain;display:block;margin:0 auto;" />
//         <div style="font-size:9px;color:#e65100;font-style:italic;font-weight:700;margin-top:3px;">We Decore your Dreams</div>
//       </td>
//     </tr>
//   </table>
//   <div style="text-align:center;margin-bottom:10px;">
//     <span style="display:inline-block;background:#ff6b00;color:#ffffff;padding:5px 32px;font-size:15px;font-weight:800;letter-spacing:3px;border-radius:4px;">ESTIMATE</span>
//   </div>
//   <div style="height:3px;background:#ff6b00;margin-bottom:12px;"></div>
//   <table style="width:100%;border-collapse:collapse;margin-bottom:12px;" cellpadding="0" cellspacing="0">
//     <tr>
//       <td style="font-size:13px;"><strong>NO: </strong><span style="color:#ff6b00;font-weight:700;">${cl.invoice_number || ''}</span></td>
//       <td style="font-size:13px;text-align:right;"><strong>DATE: </strong><span style="color:#ff6b00;font-weight:700;">${fDate(cl.invoice_date)}</span></td>
//     </tr>
//   </table>
//   <table style="width:100%;border-collapse:collapse;margin-bottom:14px;background:#fff8f3;border:1px solid #ffe0c0;" cellpadding="0" cellspacing="0">
//     <tr>
//       <td style="padding:12px 14px;vertical-align:top;width:50%;border-right:1px solid #ffe0c0;">
//         <div style="font-weight:700;color:#ff6b00;font-size:11px;text-transform:uppercase;margin-bottom:5px;">Bill To:</div>
//         <div style="font-weight:700;font-size:14px;">${cl.customer_name || ''}</div>
//         <div style="color:#555;margin-top:4px;line-height:1.6;font-size:13px;">${(cl.customer_address || '').replace(/\n/g, '<br/>')}</div>
//         ${phoneHTML}${gstNoHTML}
//       </td>
//       <td style="padding:12px 14px;vertical-align:top;">
//         <div style="font-size:13px;line-height:2;">
//           <div><strong>Estimate No:</strong> <span style="color:#ff6b00;font-weight:700;">${cl.invoice_number || ''}</span></div>
//           <div><strong>Date:</strong> ${fDate(cl.invoice_date)}</div>
//           <div><strong>Payment:</strong> Cash / Credit</div>
//         </div>
//       </td>
//     </tr>
//   </table>
//   <table style="width:100%;border-collapse:collapse;margin-bottom:14px;" cellpadding="0" cellspacing="0">
//     <thead>
//       <tr style="background:#ff6b00;color:#ffffff;">
//         <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:38px;font-size:13px;">S.No</th>
//         <th style="padding:10px 8px;border:1px solid #e07000;text-align:left;font-size:13px;">Description</th>
//         <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:62px;font-size:13px;">Length</th>
//         <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:62px;font-size:13px;">Height</th>
//         <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:70px;font-size:13px;">Sqft/Qty</th>
//         <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:80px;font-size:13px;">Rate(&#8377;)</th>
//         <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:90px;font-size:13px;">Total(&#8377;)</th>
//       </tr>
//     </thead>
//     <tbody>
//       ${rowsHTML}
//       ${emptyRowsHTML}
//     </tbody>
//   </table>
//   <table style="width:100%;border-collapse:collapse;margin-bottom:14px;" cellpadding="0" cellspacing="0">
//     <tr>
//       <td style="vertical-align:bottom;">
//         <div style="font-size:11px;color:#555;">
//           <div style="font-weight:700;margin-bottom:3px;">A/C DETAILS - CANARA BANK</div>
//           <div>AKSHAYA WOOD FURNITURE &amp; INTERIORS</div>
//           <div>A/C NO: 120024165827 &nbsp;|&nbsp; IFSC: CNRB0003972</div>
//         </div>
//       </td>
//       <td style="text-align:right;vertical-align:bottom;">
//         <table style="border-collapse:collapse;font-size:13px;min-width:245px;margin-left:auto;" cellpadding="0" cellspacing="0">
//           <tr>
//             <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;font-weight:600;background:#f9f9f9;">SUBTOTAL:</td>
//             <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;">&#8377;${subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//           </tr>
//           ${gstRowsHTML}
//           <tr>
//             <td style="padding:9px 12px;background:#ff6b00;color:#ffffff;font-weight:800;text-align:right;font-size:14px;">NET AMOUNT:</td>
//             <td style="padding:9px 12px;background:#ff6b00;color:#ffffff;font-weight:800;text-align:right;font-size:14px;">&#8377;${net.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//           </tr>
//         </table>
//       </td>
//     </tr>
//   </table>
//   ${notesHTML}
//   <div style="border:1px solid #ddd;border-radius:5px;padding:10px 13px;margin-bottom:18px;font-size:13px;background:#fff8f3;">
//     <strong>RUPEES: </strong>${numberToWords(net)}
//   </div>
//   <table style="width:100%;border-collapse:collapse;font-size:12px;color:#555;margin-bottom:22px;" cellpadding="0" cellspacing="0">
//     <tr>
//       <td style="vertical-align:top;width:55%;padding-right:20px;">
//         <strong>Declaration:</strong><br/><br/>
//         We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.
//       </td>
//       <td style="text-align:right;vertical-align:bottom;">
//         <div style="font-weight:700;margin-bottom:42px;">For Akshaya Wood Furniture</div>
//         <div>Authorised Signatory</div>
//       </td>
//     </tr>
//   </table>
//   <div style="background:#ff6b00;color:#ffffff;text-align:center;padding:10px;font-weight:800;letter-spacing:3px;font-size:13px;border-radius:4px;">
//     BEST QUALITY * BEST PRICE
//   </div>
// </div>`;
// }

// // ============================================================
// // printViaIframe — THE REAL FIX FOR BLANK PDF PROBLEM
// //
// // WHY html2canvas FAILS:  it screenshots the DOM pixels.
// // If anything isn't painted yet → blank white screenshot.
// //
// // WHY iframe WORKS:  browser renders the HTML natively inside
// // the iframe (same engine as normal page load), then calls
// // print() on it. Browser knows how to render its own HTML
// // perfectly — no screenshots, no canvas, no blank pages.
// //
// // Desktop : Print dialog → "Save as PDF" destination
// // Mobile  : Print dialog → tap ⋮ → "Save as PDF"
// // ============================================================
// function printViaIframe(htmlBody, title) {
//   const old = document.getElementById('__inv_print_frame__');
//   if (old) old.parentNode.removeChild(old);

//   const iframe = document.createElement('iframe');
//   iframe.id = '__inv_print_frame__';
//   // Key: real dimensions so browser fully renders the content
//   // opacity:0 so user doesn't see it flash on screen
//   iframe.style.cssText = [
//     'position:fixed', 'top:0', 'left:0',
//     'width:210mm', 'height:297mm',
//     'border:none', 'opacity:0',
//     'pointer-events:none', 'z-index:9999'
//   ].join(';');
//   document.body.appendChild(iframe);

//   const doc = iframe.contentWindow.document;
//   doc.open();
//   doc.write(`<!DOCTYPE html><html><head>
//     <meta charset="utf-8"/>
//     <title>${title}</title>
//     <style>
//       @page { size:A4 portrait; margin:8mm; }
//       * { margin:0; padding:0; box-sizing:border-box;
//           -webkit-print-color-adjust:exact !important;
//           print-color-adjust:exact !important; }
//       body { font-family:Arial,Helvetica,sans-serif; background:#fff; }
//       table { border-collapse:collapse; }
//     </style>
//   </head><body>${htmlBody}</body></html>`);
//   doc.close();

//   iframe.onload = () => {
//     // Wait for all images inside iframe to fully load
//     const imgs = Array.from(iframe.contentDocument.querySelectorAll('img'));
//     Promise.all(imgs.map(img => new Promise(res => {
//       if (img.complete && img.naturalWidth > 0) { res(); return; }
//       img.onload = res;
//       img.onerror = res;
//     }))).then(() => {
//       // 400ms buffer for fonts & layout to settle
//       setTimeout(() => {
//         iframe.contentWindow.focus();
//         iframe.contentWindow.print();
//         // Remove iframe after print dialog is done
//         setTimeout(() => {
//           if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
//         }, 5000);
//       }, 400);
//     });
//   };
// }

// // ============================================================
// function InvoicePage() {
//   const navigate = useNavigate();
//   const [saving, setSaving] = useState(false);
//   const [saved, setSaved] = useState(false);
//   const [notes, setNotes] = useState('');
//   const [logoDataURL, setLogoDataURL] = useState('');

//   const rows = JSON.parse(localStorage.getItem('invoice_rows') || '[]').filter(r => r.description || r.total_rate);
//   const cl = JSON.parse(localStorage.getItem('invoice_checklist') || '{}');

//   const subtotal = rows.reduce((s, r) => s + (parseFloat(r.total_rate) || 0), 0);
//   const sgst = cl.has_gst ? subtotal * 0.09 : 0;
//   const cgst = cl.has_gst ? subtotal * 0.09 : 0;
//   const net = subtotal + sgst + cgst;
//   const emptyCount = Math.max(0, 8 - rows.length);

//   // Convert logo to base64 — critical for iframe to show logo without CORS block
//   useEffect(() => {
//     const img = new Image();
//     img.crossOrigin = 'anonymous';
//     img.onload = () => {
//       const canvas = document.createElement('canvas');
//       canvas.width = img.width;
//       canvas.height = img.height;
//       canvas.getContext('2d').drawImage(img, 0, 0);
//       try { setLogoDataURL(canvas.toDataURL('image/png')); }
//       catch { setLogoDataURL(logo); }
//     };
//     img.onerror = () => setLogoDataURL(logo);
//     img.src = logo;
//   }, []);

//   useEffect(() => {
//     const s = localStorage.getItem('invoice_notes');
//     if (s) setNotes(s);
//   }, []);

//   const handleNotesChange = (e) => {
//     setNotes(e.target.value);
//     localStorage.setItem('invoice_notes', e.target.value);
//   };

//   const getHTMLBody = () => buildInvoiceHTML({
//     logoSrc: logoDataURL || logo,
//     rows, cl, subtotal, sgst, cgst, net, notes, emptyCount
//   });

//   // Print and Download PDF both use iframe — guaranteed no blank pages
//   const handlePrint = () => {
//     printViaIframe(getHTMLBody(), `Estimate_${cl.invoice_number || 'Akshaya'}`);
//   };

//   const handleDownloadPDF = () => {
//     printViaIframe(getHTMLBody(), `Estimate_${cl.invoice_number || 'Akshaya'}`);
//   };

//   const handleSave = async () => {
//     setSaving(true);
//     try {
//       // await axios.post('http://localhost:5000/api/invoices', {
//       await axios.post('https://api.invoice.nimutechnology.com/api/invoices', {
//         invoice_number: cl.invoice_number, customer_name: cl.customer_name,
//         customer_address: cl.customer_address, customer_gst: cl.customer_gst || '',
//         invoice_date: cl.invoice_date, has_gst: cl.has_gst,
//         items: rows.map((r, i) => ({ sno: i + 1, description: r.description, length: r.length || 0, height: r.height || 0, sqft: r.sqft || 0, rate: r.rate || 0, total_rate: r.total_rate || 0 })),
//         subtotal, sgst, cgst, net_amount: net, notes
//       });
//       setSaved(true); alert('Saved successfully!');
//     } catch { alert('DB save failed. You can still print.'); }
//     finally { setSaving(false); }
//   };

//   const handleNew = () => {
//     if (window.confirm('Start a new estimate?')) {
//       localStorage.removeItem('invoice_rows');
//       localStorage.removeItem('invoice_checklist');
//       localStorage.removeItem('invoice_notes');
//       navigate('/');
//     }
//   };

//   if (!cl.customer_name) return (
//     <div style={{ textAlign: 'center', paddingTop: '60px' }}>
//       <p style={{ marginBottom: '20px', fontSize: '16px' }}>Customer details not found.</p>
//       <button onClick={() => navigate('/checklist')} style={{ background: '#ff6b00', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 24px', cursor: 'pointer', fontSize: '15px' }}>
//         Go to Checklist
//       </button>
//     </div>
//   );

//   return (
//     <div style={{ background: '#f0f0f0', minHeight: '100vh' }}>
//       <style>{`
//         .inv-btn { border:none; border-radius:7px; padding:10px 18px; cursor:pointer; font-size:14px; font-weight:700; white-space:nowrap; transition:opacity 0.2s; }
//         .inv-btn:hover { opacity:0.88; }
//         .inv-table-scroll { overflow-x:auto; -webkit-overflow-scrolling:touch; }
//         .notes-box textarea { width:100%; border:1px solid #ffcc99; border-radius:6px; padding:10px; font-size:13px; font-family:Arial,sans-serif; resize:vertical; background:#fff8f3; box-sizing:border-box; }
//         .notes-box textarea:focus { outline:none; border-color:#ff6b00; box-shadow:0 0 0 2px rgba(255,107,0,0.2); }
//         @media(max-width:520px){ .inv-btn{ padding:8px 11px; font-size:12px; } }
//       `}</style>

//       {/* ── ACTION BAR ── */}
//       <div style={{ background: 'white', padding: '11px 18px', boxShadow: '0 2px 8px rgba(0,0,0,0.12)', display: 'flex', gap: '9px', alignItems: 'center', flexWrap: 'wrap', position: 'sticky', top: 0, zIndex: 100 }}>
//         <button className="inv-btn" onClick={() => navigate('/checklist')} style={{ background: '#607d8b', color: 'white' }}>← Edit</button>
//         <button className="inv-btn" onClick={handleSave} disabled={saving || saved} style={{ background: saved ? '#43a047' : '#1976d2', color: 'white', opacity: saving ? 0.7 : 1 }}>
//           {saved ? '✅ Saved' : saving ? 'Saving...' : '💾 Save'}
//         </button>
//         <button className="inv-btn" onClick={handlePrint} style={{ background: '#ff6b00', color: 'white', boxShadow: '0 3px 10px rgba(255,107,0,0.35)' }}>🖨️ Print</button>
//         <button className="inv-btn" onClick={handleDownloadPDF} style={{ background: '#1565c0', color: 'white', boxShadow: '0 3px 10px rgba(21,101,192,0.35)' }}>⬇️ Download PDF</button>
//         <button className="inv-btn" onClick={handleNew} style={{ background: '#43a047', color: 'white' }}>📄 New</button>
//         <span style={{ fontSize: '11px', color: '#bbb', fontStyle: 'italic' }}>Print dialog → "Save as PDF"</span>
//       </div>

//       {/* ── PREVIEW ── */}
//       <div style={{ padding: '24px 12px', display: 'flex', justifyContent: 'center', overflowX: 'auto' }}>
//         <div style={{ background: 'white', width: '100%', maxWidth: '794px', minHeight: '1123px', boxShadow: '0 4px 24px rgba(0,0,0,0.15)', borderRadius: '4px', overflow: 'hidden', fontFamily: 'Arial,Helvetica,sans-serif', color: '#000' }}>

//           <div style={{ height: '8px', background: '#ff6b00' }} />

//           <table style={{ width: '100%', borderCollapse: 'collapse', padding: '14px 18px 8px' }} cellPadding="0" cellSpacing="0">
//             <tbody>
//               <tr>
//                 <td style={{ width: '110px', verticalAlign: 'middle' }} />
//                 <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '14px 10px 8px' }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', fontWeight: '700', color: '#444', marginBottom: '5px' }}>
//                     <span>GST: 33CGAPS5480A2ZN</span>
//                     <span>Cell: 9965113567</span>
//                   </div>
//                   <div style={{ fontSize: '17px', fontWeight: '900', color: '#0a0a0a', lineHeight: '1', marginBottom: '4px' }}>உ</div>
//                   <div style={{ fontSize: '17px', fontWeight: '800', color: '#333', marginBottom: '4px' }}>பெத்தனசாமி துணை</div>
//                   <div style={{ fontSize: '28px', fontWeight: '900', color: '#ff6b00', letterSpacing: '2px', lineHeight: '1.2' }}>AKSHAYA</div>
//                   <div style={{ fontSize: '15px', fontWeight: '700', marginTop: '2px' }}>Wood Furniture &amp; Interiors</div>
//                   <div style={{ fontSize: '12px', color: '#555', marginTop: '5px', lineHeight: '1.6' }}>
//                     12A, Digital Garden, opposite Rainbow factory, near Sagaja Yoga Mandabam,<br />
//                     Kuralikundu Road, Annanji, Theni - 625531
//                   </div>
//                   <div style={{ fontSize: '12px', color: '#ff6b00', marginTop: '6px' }}>
//                     🌐 www.akshayainteriors.in &nbsp;|&nbsp; ✉️ akshayawoodfurnitures@gmail.com
//                   </div>
//                 </td>
//                 <td style={{ width: '110px', verticalAlign: 'middle', textAlign: 'center' }}>
//                   <img src={logo} alt="Logo" style={{ height: '95px', width: '95px', objectFit: 'contain', display: 'block', margin: '0 auto' }} onError={e => e.target.style.display = 'none'} />
//                   <div style={{ fontSize: '9px', color: '#e65100', fontStyle: 'italic', fontWeight: '700', marginTop: '3px' }}>We Decore your Dreams</div>
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           <div style={{ textAlign: 'center', margin: '6px 0 9px' }}>
//             <span style={{ display: 'inline-block', background: '#ff6b00', color: 'white', padding: '5px 32px', fontSize: '15px', fontWeight: '800', letterSpacing: '3px', borderRadius: '4px' }}>ESTIMATE</span>
//           </div>
//           <div style={{ height: '3px', background: '#ff6b00', margin: '0 16px 12px' }} />

//           <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 18px', marginBottom: '12px', fontSize: '13px' }}>
//             <div><strong>NO: </strong><span style={{ color: '#ff6b00', fontWeight: '700' }}>{cl.invoice_number}</span></div>
//             <div><strong>DATE: </strong><span style={{ color: '#ff6b00', fontWeight: '700' }}>{fDate(cl.invoice_date)}</span></div>
//           </div>

//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', margin: '0 16px 14px', background: '#fff8f3', border: '1px solid #ffe0c0', borderRadius: '6px', fontSize: '13px', overflow: 'hidden' }}>
//             <div style={{ padding: '12px 14px', borderRight: '1px solid #ffe0c0' }}>
//               <div style={{ fontWeight: '700', color: '#ff6b00', fontSize: '11px', marginBottom: '5px', textTransform: 'uppercase' }}>Bill To:</div>
//               <div style={{ fontWeight: '700', fontSize: '14px' }}>{cl.customer_name}</div>
//               <div style={{ color: '#555', marginTop: '3px', lineHeight: '1.6' }}>{cl.customer_address}</div>
//               {cl.customer_phone && <div style={{ marginTop: '3px' }}><strong>Phone:</strong> {cl.customer_phone}</div>}
//               {cl.has_gst && cl.customer_gst && <div style={{ marginTop: '3px' }}><strong>GST No:</strong> {cl.customer_gst}</div>}
//             </div>
//             <div style={{ padding: '12px 14px', lineHeight: '2.1' }}>
//               <div><strong>Estimate No:</strong> <span style={{ color: '#ff6b00', fontWeight: '700' }}>{cl.invoice_number}</span></div>
//               <div><strong>Date:</strong> {fDate(cl.invoice_date)}</div>
//               <div><strong>Payment:</strong> Cash / Credit</div>
//             </div>
//           </div>

//           <div className="inv-table-scroll" style={{ padding: '0 16px', marginBottom: '14px' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', minWidth: '500px' }}>
//               <thead>
//                 <tr style={{ background: '#ff6b00', color: 'white' }}>
//                   {['S.No', 'Description', 'Length', 'Height', 'Sqft/Qty', 'Rate(₹)', 'Total(₹)'].map((h, i) => (
//                     <th key={i} style={{ padding: '10px 8px', border: '1px solid #e07000', textAlign: i === 1 ? 'left' : 'center', whiteSpace: 'nowrap' }}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.map((row, i) => (
//                   <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fff8f3' }}>
//                     <td style={{ padding: '9px 8px', border: '1px solid #ddd', textAlign: 'center' }}>{i + 1}</td>
//                     <td style={{ padding: '9px 8px', border: '1px solid #ddd', fontWeight: '500' }}>{row.description}</td>
//                     <td style={{ padding: '9px 8px', border: '1px solid #ddd', textAlign: 'center' }}>{row.length || '-'}</td>
//                     <td style={{ padding: '9px 8px', border: '1px solid #ddd', textAlign: 'center' }}>{row.height || '-'}</td>
//                     <td style={{ padding: '9px 8px', border: '1px solid #ddd', textAlign: 'center' }}>{row.sqft || '-'}</td>
//                     <td style={{ padding: '9px 8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.rate ? `₹${parseFloat(row.rate).toLocaleString('en-IN')}` : '-'}</td>
//                     <td style={{ padding: '9px 8px', border: '1px solid #ddd', textAlign: 'right', fontWeight: '600' }}>{row.total_rate ? `₹${parseFloat(row.total_rate).toLocaleString('en-IN')}` : '-'}</td>
//                   </tr>
//                 ))}
//                 {Array.from({ length: emptyCount }).map((_, i) => (
//                   <tr key={`e${i}`}>{Array(7).fill(0).map((_, j) => <td key={j} style={{ padding: '11px 8px', border: '1px solid #ddd' }}>&nbsp;</td>)}</tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', padding: '0 16px', marginBottom: '14px', flexWrap: 'wrap', gap: '10px' }}>
//             <div style={{ fontSize: '11px', color: '#555' }}>
//               <div style={{ fontWeight: '700', marginBottom: '3px' }}>A/C DETAILS - CANARA BANK</div>
//               <div>AKSHAYA WOOD FURNITURE &amp; INTERIORS</div>
//               <div>A/C NO: 120024165827 | IFSC: CNRB0003972</div>
//             </div>
//             <table style={{ borderCollapse: 'collapse', fontSize: '13px', minWidth: '245px' }}>
//               <tbody>
//                 <tr>
//                   <td style={{ padding: '6px 12px', border: '1px solid #ddd', textAlign: 'right', fontWeight: '600', background: '#f9f9f9' }}>SUBTOTAL:</td>
//                   <td style={{ padding: '6px 12px', border: '1px solid #ddd', textAlign: 'right' }}>₹{subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//                 </tr>
//                 {cl.has_gst && <>
//                   <tr>
//                     <td style={{ padding: '6px 12px', border: '1px solid #ddd', textAlign: 'right', background: '#f9f9f9' }}>SGST (9%):</td>
//                     <td style={{ padding: '6px 12px', border: '1px solid #ddd', textAlign: 'right' }}>₹{sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//                   </tr>
//                   <tr>
//                     <td style={{ padding: '6px 12px', border: '1px solid #ddd', textAlign: 'right', background: '#f9f9f9' }}>CGST (9%):</td>
//                     <td style={{ padding: '6px 12px', border: '1px solid #ddd', textAlign: 'right' }}>₹{cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//                   </tr>
//                 </>}
//                 <tr>
//                   <td style={{ padding: '9px 12px', background: '#ff6b00', color: 'white', fontWeight: '800', textAlign: 'right', fontSize: '14px' }}>NET AMOUNT:</td>
//                   <td style={{ padding: '9px 12px', background: '#ff6b00', color: 'white', fontWeight: '800', textAlign: 'right', fontSize: '14px' }}>₹{net.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div className="notes-box" style={{ padding: '0 16px', marginBottom: '14px' }}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
//               <span style={{ fontWeight: '700', color: '#ff6b00', fontSize: '13px' }}>📝 Notes / Comments:</span>
//               <span style={{ fontSize: '12px', color: '#aaa' }}>(Optional - appears on estimate)</span>
//             </div>
//             <textarea rows="3" placeholder="Enter additional notes, delivery instructions, payment terms, etc..."
//               value={notes} onChange={handleNotesChange} />
//           </div>

//           <div style={{ margin: '0 16px 16px', border: '1px solid #ddd', borderRadius: '5px', padding: '10px 13px', fontSize: '13px', background: '#fff8f3' }}>
//             <strong>RUPEES: </strong>{numberToWords(net)}
//           </div>

//           <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 16px', marginBottom: '20px', fontSize: '12px', color: '#555', flexWrap: 'wrap', gap: '10px' }}>
//             <div style={{ maxWidth: '55%', minWidth: '200px' }}>
//               <strong>Declaration:</strong><br /><br />
//               We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.
//             </div>
//             <div style={{ textAlign: 'right' }}>
//               <div style={{ fontWeight: '700', marginBottom: '42px' }}>For Akshaya Wood Furniture</div>
//               <div>Authorised Signatory</div>
//             </div>
//           </div>

//           <div style={{ margin: '0 16px 18px', background: '#ff6b00', color: 'white', textAlign: 'center', padding: '10px', fontWeight: '800', letterSpacing: '2px', fontSize: '13px', borderRadius: '4px' }}>
//             ⭐ BEST QUALITY * BEST PRICE ⭐
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }

// export default InvoicePage;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import axios from 'axios';

function numberToWords(num) {
  const ones = ['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
  const tens = ['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
  if (num === 0) return 'Zero';
  function convert(n) {
    if (n < 20) return ones[n];
    if (n < 100) return tens[Math.floor(n/10)] + (n%10 ? ' '+ones[n%10] : '');
    if (n < 1000) return ones[Math.floor(n/100)]+' Hundred'+(n%100 ? ' '+convert(n%100) : '');
    if (n < 100000) return convert(Math.floor(n/1000))+' Thousand'+(n%1000 ? ' '+convert(n%1000) : '');
    if (n < 10000000) return convert(Math.floor(n/100000))+' Lakh'+(n%100000 ? ' '+convert(n%100000) : '');
    return convert(Math.floor(n/10000000))+' Crore'+(n%10000000 ? ' '+convert(n%10000000) : '');
  }
  const r = Math.floor(num);
  const p = Math.round((num - r) * 100);
  return convert(r)+' Rupees'+(p > 0 ? ' and '+convert(p)+' Paise' : '')+' Only';
}

function fDate(s) {
  if (!s) return '';
  const d = new Date(s);
  return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
}

function buildInvoiceHTML({ logoSrc, rows, cl, subtotal, discount, afterDiscount, sgst, cgst, net, notes, emptyCount }) {
  const rowsHTML = rows.map((r, i) => `
    <tr style="background:${i%2===0?'#ffffff':'#fff8f3'};">
      <td style="padding:9px 8px;border:1px solid #ddd;text-align:center;font-size:13px;">${i+1}</td>
      <td style="padding:9px 8px;border:1px solid #ddd;font-weight:500;font-size:13px;">${r.description||''}</td>
      <td style="padding:9px 8px;border:1px solid #ddd;text-align:center;font-size:13px;">${r.length||'-'}</td>
      <td style="padding:9px 8px;border:1px solid #ddd;text-align:center;font-size:13px;">${r.height||'-'}</td>
      <td style="padding:9px 8px;border:1px solid #ddd;text-align:center;font-size:13px;">${r.sqft||'-'}</td>
      <td style="padding:9px 8px;border:1px solid #ddd;text-align:right;font-size:13px;">${r.rate?'&#8377;'+parseFloat(r.rate).toLocaleString('en-IN'):'-'}</td>
      <td style="padding:9px 8px;border:1px solid #ddd;text-align:right;font-weight:600;font-size:13px;">${r.total_rate?'&#8377;'+parseFloat(r.total_rate).toLocaleString('en-IN'):'-'}</td>
    </tr>`).join('');

  const emptyRowsHTML = Array.from({length: emptyCount}).map(() =>
    <tr>${Array(7).fill('<td style="padding:11px 8px;border:1px solid #ddd;">&nbsp;</td>').join('')}</tr>
  ).join('');

  // ── DISCOUNT ROW in HTML (only if discount > 0) ──
  const discountRowHTML = discount > 0 ? `
    <tr>
      <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;background:#e8f5e9;font-size:13px;color:#2e7d32;">DISCOUNT:</td>
      <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;font-size:13px;color:#2e7d32;">- &#8377;${discount.toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
    </tr>` : '';

  const gstRowsHTML = cl.has_gst ? `
    <tr>
      <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;background:#f9f9f9;font-size:13px;">SGST (9%):</td>
      <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;font-size:13px;">&#8377;${sgst.toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
    </tr>
    <tr>
      <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;background:#f9f9f9;font-size:13px;">CGST (9%):</td>
      <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;font-size:13px;">&#8377;${cgst.toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
    </tr>` : '';

  const phoneHTML = cl.customer_phone
    ? <div style="margin-top:4px;font-size:13px;"><strong>Phone:</strong> ${cl.customer_phone}</div> : '';
  const gstNoHTML = cl.has_gst && cl.customer_gst
    ? <div style="margin-top:4px;font-size:13px;"><strong>GST No:</strong> ${cl.customer_gst}</div> : '';

  const notesHTML = notes ? `
    <div style="background:#fff8f3;border:1px solid #ffcc99;border-radius:6px;padding:10px 13px;margin:0 0 13px 0;font-size:12px;">
      <div style="font-weight:700;color:#ff6b00;margin-bottom:5px;font-size:11px;text-transform:uppercase;">Notes / Comments:</div>
      <div style="white-space:pre-wrap;font-size:12px;color:#555;line-height:1.5;">${notes.replace(/</g,'&lt;').replace(/>/g,'&gt;')}</div>
    </div>` : '';

  return `
<div style="width:100%;font-family:Arial,Helvetica,sans-serif;font-size:13px;color:#000000;background:#ffffff;padding:18px 22px;box-sizing:border-box;">
  <div style="height:8px;background:#ff6b00;margin-bottom:14px;"></div>
  <table style="width:100%;border-collapse:collapse;margin-bottom:10px;" cellpadding="0" cellspacing="0">
    <tr>
      <td style="width:110px;vertical-align:middle;"></td>
      <td style="text-align:center;vertical-align:middle;padding:0 10px;">
        <table style="width:100%;border-collapse:collapse;margin-bottom:5px;" cellpadding="0" cellspacing="0">
          <tr>
            <td style="font-size:12px;font-weight:700;color:#444;text-align:left;">GST: 33CGAPS5480A2ZN</td>
            <td style="font-size:12px;font-weight:700;color:#444;text-align:right;">Cell: 9965113567</td>
          </tr>
        </table>
        <div style="font-size:17px;font-weight:900;color:#0a0a0a;line-height:1;margin-bottom:4px;">உ</div>
        <div style="font-size:17px;font-weight:800;color:#333;margin-bottom:4px;">பெத்தனசாமி துணை</div>
        <div style="font-size:28px;font-weight:900;color:#ff6b00;letter-spacing:2px;line-height:1.15;">AKSHAYA</div>
        <div style="font-size:15px;font-weight:700;color:#333;margin-top:2px;">Wood Furniture &amp; Interiors</div>
        <div style="font-size:12px;color:#555;margin-top:5px;line-height:1.6;">
          12A, Digital Garden, opposite Rainbow factory, near Sagaja Yoga Mandabam,<br/>
          Kuralikundu Road, Annanji, Theni - 625531
        </div>
        <div style="font-size:12px;color:#ff6b00;margin-top:6px;">
          www.akshayainteriors.in &nbsp;|&nbsp; akshayawoodfurnitures@gmail.com
        </div>
      </td>
      <td style="width:110px;vertical-align:middle;text-align:center;">
        <img src="${logoSrc}" alt="Logo" style="height:95px;width:95px;object-fit:contain;display:block;margin:0 auto;" />
        <div style="font-size:9px;color:#e65100;font-style:italic;font-weight:700;margin-top:3px;">We Decore your Dreams</div>
      </td>
    </tr>
  </table>
  <div style="text-align:center;margin-bottom:10px;">
    <span style="display:inline-block;background:#ff6b00;color:#ffffff;padding:5px 32px;font-size:15px;font-weight:800;letter-spacing:3px;border-radius:4px;">ESTIMATE</span>
  </div>
  <div style="height:3px;background:#ff6b00;margin-bottom:12px;"></div>
  <table style="width:100%;border-collapse:collapse;margin-bottom:12px;" cellpadding="0" cellspacing="0">
    <tr>
      <td style="font-size:13px;"><strong>NO: </strong><span style="color:#ff6b00;font-weight:700;">${cl.invoice_number||''}</span></td>
      <td style="font-size:13px;text-align:right;"><strong>DATE: </strong><span style="color:#ff6b00;font-weight:700;">${fDate(cl.invoice_date)}</span></td>
    </tr>
  </table>
  <table style="width:100%;border-collapse:collapse;margin-bottom:14px;background:#fff8f3;border:1px solid #ffe0c0;" cellpadding="0" cellspacing="0">
    <tr>
      <td style="padding:12px 14px;vertical-align:top;width:50%;border-right:1px solid #ffe0c0;">
        <div style="font-weight:700;color:#ff6b00;font-size:11px;text-transform:uppercase;margin-bottom:5px;">Bill To:</div>
        <div style="font-weight:700;font-size:14px;">${cl.customer_name||''}</div>
        <div style="color:#555;margin-top:4px;line-height:1.6;font-size:13px;">${(cl.customer_address||'').replace(/\n/g,'<br/>')}</div>
        ${phoneHTML}${gstNoHTML}
      </td>
      <td style="padding:12px 14px;vertical-align:top;">
        <div style="font-size:13px;line-height:2;">
          <div><strong>Estimate No:</strong> <span style="color:#ff6b00;font-weight:700;">${cl.invoice_number||''}</span></div>
          <div><strong>Date:</strong> ${fDate(cl.invoice_date)}</div>
          <div><strong>Payment:</strong> Cash / Credit</div>
        </div>
      </td>
    </tr>
  </table>
  <table style="width:100%;border-collapse:collapse;margin-bottom:14px;" cellpadding="0" cellspacing="0">
    <thead>
      <tr style="background:#ff6b00;color:#ffffff;">
        <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:38px;font-size:13px;">S.No</th>
        <th style="padding:10px 8px;border:1px solid #e07000;text-align:left;font-size:13px;">Description</th>
        <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:62px;font-size:13px;">Length</th>
        <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:62px;font-size:13px;">Height</th>
        <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:70px;font-size:13px;">Sqft/Qty</th>
        <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:80px;font-size:13px;">Rate(&#8377;)</th>
        <th style="padding:10px 8px;border:1px solid #e07000;text-align:center;width:90px;font-size:13px;">Total(&#8377;)</th>
      </tr>
    </thead>
    <tbody>
      ${rowsHTML}
      ${emptyRowsHTML}
    </tbody>
  </table>
  <table style="width:100%;border-collapse:collapse;margin-bottom:14px;" cellpadding="0" cellspacing="0">
    <tr>
      <td style="vertical-align:bottom;">
        <div style="font-size:11px;color:#555;">
          <div style="font-weight:700;margin-bottom:3px;">A/C DETAILS - CANARA BANK</div>
          <div>AKSHAYA WOOD FURNITURE &amp; INTERIORS</div>
          <div>A/C NO: 120024165827 &nbsp;|&nbsp; IFSC: CNRB0003972</div>
        </div>
      </td>
      <td style="text-align:right;vertical-align:bottom;">
        <table style="border-collapse:collapse;font-size:13px;min-width:245px;margin-left:auto;" cellpadding="0" cellspacing="0">
          <tr>
            <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;font-weight:600;background:#f9f9f9;">SUBTOTAL:</td>
            <td style="padding:6px 12px;border:1px solid #ddd;text-align:right;">&#8377;${subtotal.toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
          </tr>
          ${discountRowHTML}
          ${gstRowsHTML}
          <tr>
            <td style="padding:9px 12px;background:#ff6b00;color:#ffffff;font-weight:800;text-align:right;font-size:14px;">NET AMOUNT:</td>
            <td style="padding:9px 12px;background:#ff6b00;color:#ffffff;font-weight:800;text-align:right;font-size:14px;">&#8377;${net.toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
  ${notesHTML}
  <div style="border:1px solid #ddd;border-radius:5px;padding:10px 13px;margin-bottom:18px;font-size:13px;background:#fff8f3;">
    <strong>RUPEES: </strong>${numberToWords(net)}
  </div>
  <table style="width:100%;border-collapse:collapse;font-size:12px;color:#555;margin-bottom:22px;" cellpadding="0" cellspacing="0">
    <tr>
      <td style="vertical-align:top;width:55%;padding-right:20px;">
        <strong>Declaration:</strong><br/><br/>
        We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.
      </td>
      <td style="text-align:right;vertical-align:bottom;">
        <div style="font-weight:700;margin-bottom:42px;">For Akshaya Wood Furniture</div>
        <div>Authorised Signatory</div>
      </td>
    </tr>
  </table>
  <div style="background:#ff6b00;color:#ffffff;text-align:center;padding:10px;font-weight:800;letter-spacing:3px;font-size:13px;border-radius:4px;">
    BEST QUALITY * BEST PRICE
  </div>
</div>`;
}

// ============================================================
function printViaIframe(htmlBody, title) {
  const old = document.getElementById('_inv_print_frame_');
  if (old) old.parentNode.removeChild(old);

  const iframe = document.createElement('iframe');
  iframe.id = '_inv_print_frame_';
  iframe.style.cssText = [
    'position:fixed', 'top:0', 'left:0',
    'width:210mm', 'height:297mm',
    'border:none', 'opacity:0',
    'pointer-events:none', 'z-index:9999'
  ].join(';');
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(`<!DOCTYPE html><html><head>
    <meta charset="utf-8"/>
    <title>${title}</title>
    <style>
      @page { size:A4 portrait; margin:8mm; }
      * { margin:0; padding:0; box-sizing:border-box;
          -webkit-print-color-adjust:exact !important;
          print-color-adjust:exact !important; }
      body { font-family:Arial,Helvetica,sans-serif; background:#fff; }
      table { border-collapse:collapse; }
    </style>
  </head><body>${htmlBody}</body></html>`);
  doc.close();

  iframe.onload = () => {
    const imgs = Array.from(iframe.contentDocument.querySelectorAll('img'));
    Promise.all(imgs.map(img => new Promise(res => {
      if (img.complete && img.naturalWidth > 0) { res(); return; }
      img.onload = res;
      img.onerror = res;
    }))).then(() => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 5000);
      }, 400);
    });
  };
}

// ============================================================
function InvoicePage() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [notes, setNotes] = useState('');
  const [logoDataURL, setLogoDataURL] = useState('');
  // ── NEW: discount state ──
  const [discount, setDiscount] = useState(() => {
    const s = localStorage.getItem('invoice_discount');
    return s ? parseFloat(s) || 0 : 0;
  });

  const rows = JSON.parse(localStorage.getItem('invoice_rows') || '[]').filter(r => r.description || r.total_rate);
  const cl = JSON.parse(localStorage.getItem('invoice_checklist') || '{}');

  const subtotal = rows.reduce((s, r) => s + (parseFloat(r.total_rate) || 0), 0);
  // ── NEW: discount applied before GST ──
  const afterDiscount = Math.max(0, subtotal - discount);
  const sgst = cl.has_gst ? afterDiscount * 0.09 : 0;
  const cgst = cl.has_gst ? afterDiscount * 0.09 : 0;
  const net = afterDiscount + sgst + cgst;
  const emptyCount = Math.max(0, 8 - rows.length);

  useEffect(() => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext('2d').drawImage(img, 0, 0);
      try { setLogoDataURL(canvas.toDataURL('image/png')); }
      catch { setLogoDataURL(logo); }
    };
    img.onerror = () => setLogoDataURL(logo);
    img.src = logo;
  }, []);

  useEffect(() => {
    const s = localStorage.getItem('invoice_notes');
    if (s) setNotes(s);
  }, []);

  const handleNotesChange = (e) => {
    setNotes(e.target.value);
    localStorage.setItem('invoice_notes', e.target.value);
  };

  // ── NEW: discount change handler ──
  const handleDiscountChange = (e) => {
    const val = parseFloat(e.target.value) || 0;
    setDiscount(val);
    localStorage.setItem('invoice_discount', val.toString());
  };

  const getHTMLBody = () => buildInvoiceHTML({
    logoSrc: logoDataURL || logo,
    rows, cl, subtotal, discount, afterDiscount, sgst, cgst, net, notes, emptyCount
  });

  const handlePrint = () => {
    printViaIframe(getHTMLBody(), `Estimate_${cl.invoice_number || 'Akshaya'}`);
  };

  const handleDownloadPDF = () => {
    printViaIframe(getHTMLBody(), `Estimate_${cl.invoice_number || 'Akshaya'}`);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
       await axios.post('https://api.invoice.nimutechnology.com/api/invoices', {
        invoice_number: cl.invoice_number, customer_name: cl.customer_name,
        customer_address: cl.customer_address, customer_gst: cl.customer_gst||'',
        invoice_date: cl.invoice_date, has_gst: cl.has_gst,
        items: rows.map((r,i) => ({sno:i+1,description:r.description,length:r.length||0,height:r.height||0,sqft:r.sqft||0,rate:r.rate||0,total_rate:r.total_rate||0})),
        subtotal, sgst, cgst, net_amount: net, notes
      });
      setSaved(true); alert('Saved successfully!');
    } catch { alert('DB save failed. You can still print.'); }
    finally { setSaving(false); }
  };

  const handleNew = () => {
    if (window.confirm('Start a new estimate?')) {
      localStorage.removeItem('invoice_rows');
      localStorage.removeItem('invoice_checklist');
      localStorage.removeItem('invoice_notes');
      localStorage.removeItem('invoice_discount');
      navigate('/');
    }
  };

  if (!cl.customer_name) return (
    <div style={{textAlign:'center',paddingTop:'60px'}}>
      <p style={{marginBottom:'20px',fontSize:'16px'}}>Customer details not found.</p>
      <button onClick={() => navigate('/checklist')} style={{background:'#ff6b00',color:'white',border:'none',borderRadius:'8px',padding:'12px 24px',cursor:'pointer',fontSize:'15px'}}>
        Go to Checklist
      </button>
    </div>
  );

  return (
    <div style={{ background:'#f0f0f0', minHeight:'100vh' }}>
      <style>{`
        .inv-btn { border:none; border-radius:7px; padding:10px 18px; cursor:pointer; font-size:14px; font-weight:700; white-space:nowrap; transition:opacity 0.2s; }
        .inv-btn:hover { opacity:0.88; }
        .inv-table-scroll { overflow-x:auto; -webkit-overflow-scrolling:touch; }
        .notes-box textarea { width:100%; border:1px solid #ffcc99; border-radius:6px; padding:10px; font-size:13px; font-family:Arial,sans-serif; resize:vertical; background:#fff8f3; box-sizing:border-box; }
        .notes-box textarea:focus { outline:none; border-color:#ff6b00; box-shadow:0 0 0 2px rgba(255,107,0,0.2); }
        @media(max-width:520px){ .inv-btn{ padding:8px 11px; font-size:12px; } }
      `}</style>

      {/* ── ACTION BAR ── */}
      <div style={{ background:'white', padding:'11px 18px', boxShadow:'0 2px 8px rgba(0,0,0,0.12)', display:'flex', gap:'9px', alignItems:'center', flexWrap:'wrap', position:'sticky', top:0, zIndex:100 }}>
        <button className="inv-btn" onClick={() => navigate('/checklist')} style={{ background:'#607d8b', color:'white' }}>← Edit</button>
        <button className="inv-btn" onClick={handleSave} disabled={saving||saved} style={{ background:saved?'#43a047':'#1976d2', color:'white', opacity:saving?0.7:1 }}>
          {saved ? '✅ Saved' : saving ? 'Saving...' : '💾 Save'}
        </button>
        <button className="inv-btn" onClick={handlePrint} style={{ background:'#ff6b00', color:'white', boxShadow:'0 3px 10px rgba(255,107,0,0.35)' }}>🖨️ Print</button>
        <button className="inv-btn" onClick={handleDownloadPDF} style={{ background:'#1565c0', color:'white', boxShadow:'0 3px 10px rgba(21,101,192,0.35)' }}>⬇️ Download PDF</button>
        <button className="inv-btn" onClick={handleNew} style={{ background:'#43a047', color:'white' }}>📄 New</button>
        <span style={{ fontSize:'11px', color:'#bbb', fontStyle:'italic' }}>Print dialog → "Save as PDF"</span>
      </div>

      {/* ── PREVIEW ── */}
      <div style={{ padding:'24px 12px', display:'flex', justifyContent:'center', overflowX:'auto' }}>
        <div style={{ background:'white', width:'100%', maxWidth:'794px', minHeight:'1123px', boxShadow:'0 4px 24px rgba(0,0,0,0.15)', borderRadius:'4px', overflow:'hidden', fontFamily:'Arial,Helvetica,sans-serif', color:'#000' }}>

          <div style={{ height:'8px', background:'#ff6b00' }} />

          <table style={{ width:'100%', borderCollapse:'collapse', padding:'14px 18px 8px' }} cellPadding="0" cellSpacing="0">
            <tbody>
              <tr>
                <td style={{ width:'110px', verticalAlign:'middle' }} />
                <td style={{ textAlign:'center', verticalAlign:'middle', padding:'14px 10px 8px' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:'12px', fontWeight:'700', color:'#444', marginBottom:'5px' }}>
                    <span>GST: 33CGAPS5480A2ZN</span>
                    <span>Cell: 9965113567</span>
                  </div>
                  <div style={{ fontSize:'17px', fontWeight:'900', color:'#0a0a0a', lineHeight:'1', marginBottom:'4px' }}>உ</div>
                  <div style={{ fontSize:'17px', fontWeight:'800', color:'#333', marginBottom:'4px' }}>பெத்தனசாமி துணை</div>
                  <div style={{ fontSize:'28px', fontWeight:'900', color:'#ff6b00', letterSpacing:'2px', lineHeight:'1.2' }}>AKSHAYA</div>
                  <div style={{ fontSize:'15px', fontWeight:'700', marginTop:'2px' }}>Wood Furniture &amp; Interiors</div>
                  <div style={{ fontSize:'12px', color:'#555', marginTop:'5px', lineHeight:'1.6' }}>
                    12A, Digital Garden, opposite Rainbow factory, near Sagaja Yoga Mandabam,<br />
                    Kuralikundu Road, Annanji, Theni - 625531
                  </div>
                  <div style={{ fontSize:'12px', color:'#ff6b00', marginTop:'6px' }}>
                    🌐 www.akshayainteriors.in &nbsp;|&nbsp; ✉️ akshayawoodfurnitures@gmail.com
                  </div>
                </td>
                <td style={{ width:'110px', verticalAlign:'middle', textAlign:'center' }}>
                  <img src={logo} alt="Logo" style={{ height:'95px', width:'95px', objectFit:'contain', display:'block', margin:'0 auto' }} onError={e => e.target.style.display='none'} />
                  <div style={{ fontSize:'9px', color:'#e65100', fontStyle:'italic', fontWeight:'700', marginTop:'3px' }}>We Decore your Dreams</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div style={{ textAlign:'center', margin:'6px 0 9px' }}>
            <span style={{ display:'inline-block', background:'#ff6b00', color:'white', padding:'5px 32px', fontSize:'15px', fontWeight:'800', letterSpacing:'3px', borderRadius:'4px' }}>ESTIMATE</span>
          </div>
          <div style={{ height:'3px', background:'#ff6b00', margin:'0 16px 12px' }} />

          <div style={{ display:'flex', justifyContent:'space-between', padding:'0 18px', marginBottom:'12px', fontSize:'13px' }}>
            <div><strong>NO: </strong><span style={{ color:'#ff6b00', fontWeight:'700' }}>{cl.invoice_number}</span></div>
            <div><strong>DATE: </strong><span style={{ color:'#ff6b00', fontWeight:'700' }}>{fDate(cl.invoice_date)}</span></div>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', margin:'0 16px 14px', background:'#fff8f3', border:'1px solid #ffe0c0', borderRadius:'6px', fontSize:'13px', overflow:'hidden' }}>
            <div style={{ padding:'12px 14px', borderRight:'1px solid #ffe0c0' }}>
              <div style={{ fontWeight:'700', color:'#ff6b00', fontSize:'11px', marginBottom:'5px', textTransform:'uppercase' }}>Bill To:</div>
              <div style={{ fontWeight:'700', fontSize:'14px' }}>{cl.customer_name}</div>
              <div style={{ color:'#555', marginTop:'3px', lineHeight:'1.6' }}>{cl.customer_address}</div>
              {cl.customer_phone && <div style={{ marginTop:'3px' }}><strong>Phone:</strong> {cl.customer_phone}</div>}
              {cl.has_gst && cl.customer_gst && <div style={{ marginTop:'3px' }}><strong>GST No:</strong> {cl.customer_gst}</div>}
            </div>
            <div style={{ padding:'12px 14px', lineHeight:'2.1' }}>
              <div><strong>Estimate No:</strong> <span style={{ color:'#ff6b00', fontWeight:'700' }}>{cl.invoice_number}</span></div>
              <div><strong>Date:</strong> {fDate(cl.invoice_date)}</div>
              <div><strong>Payment:</strong> Cash / Credit</div>
            </div>
          </div>

          <div className="inv-table-scroll" style={{ padding:'0 16px', marginBottom:'14px' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'13px', minWidth:'500px' }}>
              <thead>
                <tr style={{ background:'#ff6b00', color:'white' }}>
                  {['S.No','Description','Length','Height','Sqft/Qty','Rate(₹)','Total(₹)'].map((h,i) => (
                    <th key={i} style={{ padding:'10px 8px', border:'1px solid #e07000', textAlign:i===1?'left':'center', whiteSpace:'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row,i) => (
                  <tr key={i} style={{ background:i%2===0?'#fff':'#fff8f3' }}>
                    <td style={{ padding:'9px 8px', border:'1px solid #ddd', textAlign:'center' }}>{i+1}</td>
                    <td style={{ padding:'9px 8px', border:'1px solid #ddd', fontWeight:'500' }}>{row.description}</td>
                    <td style={{ padding:'9px 8px', border:'1px solid #ddd', textAlign:'center' }}>{row.length||'-'}</td>
                    <td style={{ padding:'9px 8px', border:'1px solid #ddd', textAlign:'center' }}>{row.height||'-'}</td>
                    <td style={{ padding:'9px 8px', border:'1px solid #ddd', textAlign:'center' }}>{row.sqft||'-'}</td>
                    <td style={{ padding:'9px 8px', border:'1px solid #ddd', textAlign:'right' }}>{row.rate ? `₹${parseFloat(row.rate).toLocaleString('en-IN')}` : '-'}</td>
                    <td style={{ padding:'9px 8px', border:'1px solid #ddd', textAlign:'right', fontWeight:'600' }}>{row.total_rate ? `₹${parseFloat(row.total_rate).toLocaleString('en-IN')}` : '-'}</td>
                  </tr>
                ))}
                {Array.from({length:emptyCount}).map((_,i) => (
                  <tr key={`e${i}`}>{Array(7).fill(0).map((_,j) => <td key={j} style={{ padding:'11px 8px', border:'1px solid #ddd' }}>&nbsp;</td>)}</tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ── TOTALS SECTION ── */}
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', padding:'0 16px', marginBottom:'14px', flexWrap:'wrap', gap:'10px' }}>
            <div style={{ fontSize:'11px', color:'#555' }}>
              <div style={{ fontWeight:'700', marginBottom:'3px' }}>A/C DETAILS - CANARA BANK</div>
              <div>AKSHAYA WOOD FURNITURE &amp; INTERIORS</div>
              <div>A/C NO: 120024165827 | IFSC: CNRB0003972</div>
            </div>

            <table style={{ borderCollapse:'collapse', fontSize:'13px', minWidth:'245px' }}>
              <tbody>
                {/* SUBTOTAL */}
                <tr>
                  <td style={{ padding:'6px 12px', border:'1px solid #ddd', textAlign:'right', fontWeight:'600', background:'#f9f9f9' }}>SUBTOTAL:</td>
                  <td style={{ padding:'6px 12px', border:'1px solid #ddd', textAlign:'right' }}>₹{subtotal.toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
                </tr>

                {/* ── NEW: DISCOUNT ROW (editable input) ── */}
                <tr>
                  <td style={{ padding:'4px 12px', border:'1px solid #ddd', textAlign:'right', background:'#e8f5e9', color:'#2e7d32', fontWeight:'600' }}>
                    DISCOUNT:
                  </td>
                  <td style={{ padding:'4px 8px', border:'1px solid #ddd', textAlign:'right', background:'#e8f5e9' }}>
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'flex-end', gap:'4px' }}>
                      <span style={{ color:'#2e7d32', fontWeight:'600' }}>- ₹</span>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        value={discount || ''}
                        onChange={handleDiscountChange}
                        placeholder="0"
                        style={{
                          width:'90px', padding:'4px 6px',
                          border:'1px solid #a5d6a7', borderRadius:'5px',
                          fontSize:'13px', textAlign:'right',
                          color:'#2e7d32', fontWeight:'600',
                          background:'white', outline:'none'
                        }}
                        onFocus={e => e.target.style.borderColor = '#2e7d32'}
                        onBlur={e => e.target.style.borderColor = '#a5d6a7'}
                      />
                    </div>
                  </td>
                </tr>

                {/* GST rows (calculated on afterDiscount) */}
                {cl.has_gst && <>
                  <tr>
                    <td style={{ padding:'6px 12px', border:'1px solid #ddd', textAlign:'right', background:'#f9f9f9' }}>SGST (9%):</td>
                    <td style={{ padding:'6px 12px', border:'1px solid #ddd', textAlign:'right' }}>₹{sgst.toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
                  </tr>
                  <tr>
                    <td style={{ padding:'6px 12px', border:'1px solid #ddd', textAlign:'right', background:'#f9f9f9' }}>CGST (9%):</td>
                    <td style={{ padding:'6px 12px', border:'1px solid #ddd', textAlign:'right' }}>₹{cgst.toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
                  </tr>
                </>}

                {/* NET AMOUNT */}
                <tr>
                  <td style={{ padding:'9px 12px', background:'#ff6b00', color:'white', fontWeight:'800', textAlign:'right', fontSize:'14px' }}>NET AMOUNT:</td>
                  <td style={{ padding:'9px 12px', background:'#ff6b00', color:'white', fontWeight:'800', textAlign:'right', fontSize:'14px' }}>₹{net.toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="notes-box" style={{ padding:'0 16px', marginBottom:'14px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'6px' }}>
              <span style={{ fontWeight:'700', color:'#ff6b00', fontSize:'13px' }}>📝 Notes / Comments:</span>
              <span style={{ fontSize:'12px', color:'#aaa' }}>(Optional - appears on estimate)</span>
            </div>
            <textarea rows="3" placeholder="Enter additional notes, delivery instructions, payment terms, etc..."
              value={notes} onChange={handleNotesChange} />
          </div>

          <div style={{ margin:'0 16px 16px', border:'1px solid #ddd', borderRadius:'5px', padding:'10px 13px', fontSize:'13px', background:'#fff8f3' }}>
            <strong>RUPEES: </strong>{numberToWords(net)}
          </div>

          <div style={{ display:'flex', justifyContent:'space-between', padding:'0 16px', marginBottom:'20px', fontSize:'12px', color:'#555', flexWrap:'wrap', gap:'10px' }}>
            <div style={{ maxWidth:'55%', minWidth:'200px' }}>
              <strong>Declaration:</strong><br /><br />
              We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontWeight:'700', marginBottom:'42px' }}>For Akshaya Wood Furniture</div>
              <div>Authorised Signatory</div>
            </div>
          </div>

          <div style={{ margin:'0 16px 18px', background:'#ff6b00', color:'white', textAlign:'center', padding:'10px', fontWeight:'800', letterSpacing:'2px', fontSize:'13px', borderRadius:'4px' }}>
            ⭐ BEST QUALITY * BEST PRICE ⭐
          </div>

        </div>
      </div>
    </div>
  );
}

export default InvoicePage;